const dataValuationRetained = [
  { methodology: 'EV/Revenues', min: 900000000, max: 970000000, date: '02/07/2020' },
  { methodology: 'EV/EBITA', min: 880000000, max: 952000000, date: '02/07/2020' },
  { methodology: 'FCF YIELD', min: 850000000, max: 943000000, date: '02/07/2020' },
  { methodology: 'DCF', min: 887000000, max: 992000000, date: '02/07/2020' },

  { methodology: 'EV/Revenues', min: 905000000, max: 978000000, date: '06/07/2020' },
  { methodology: 'EV/EBITA', min: 890000000, max: 964000000, date: '06/07/2020' },
  { methodology: 'FCF YIELD', min: 868000000, max: 952000000, date: '06/07/2020' },
  { methodology: 'DCF', min: 895000000, max: 987000000, date: '06/07/2020' },

  { methodology: 'EV/Revenues', min: 904000000, max: 972000000, date: '09/07/2020' },
  { methodology: 'EV/EBITA', min: 892000000, max: 960000000, date: '09/07/2020' },
  { methodology: 'FCF YIELD', min: 870000000, max: 960000000, date: '09/07/2020' },
  { methodology: 'DCF', min: 892000000, max: 984000000, date: '09/07/2020' },

  { methodology: 'EV/Revenues', min: 915000000, max: 980000000, date: '13/07/2020' },
  { methodology: 'EV/EBITA', min: 890000000, max: 958000000, date: '13/07/2020' },
  { methodology: 'FCF YIELD', min: 872000000, max: 952000000, date: '13/07/2020' },
  { methodology: 'DCF', min: 892000000, max: 980000000, date: '13/07/2020' },

  { methodology: 'EV/Revenues', min: 920000000, max: 984000000, date: '14/07/2020' },
  { methodology: 'EV/EBITA', min: 888000000, max: 954000000, date: '14/07/2020' },
  { methodology: 'FCF YIELD', min: 870000000, max: 950000000, date: '14/07/2020' },
  { methodology: 'DCF', min: 896000000, max: 982000000, date: '14/07/2020' },

  { methodology: 'EV/Revenues', min: 928000000, max: 982000000, date: '15/07/2020' },
  { methodology: 'EV/EBITA', min: 891000000, max: 956000000, date: '15/07/2020' },
  { methodology: 'FCF YIELD', min: 871000000, max: 948000000, date: '15/07/2020' },
  { methodology: 'DCF', min: 900000000, max: 982000000, date: '15/07/2020' },

  { methodology: 'EV/Revenues', min: 934000000, max: 994000000, date: '17/07/2020' },
  { methodology: 'EV/EBITA', min: 892000000, max: 954000000, date: '17/07/2020' },
  { methodology: 'FCF YIELD', min: 876000000, max: 948000000, date: '17/07/2020' },
  { methodology: 'DCF', min: 898000000, max: 982000000, date: '17/07/2020' },

  { methodology: 'EV/Revenues', min: 937000000, max: 995000000, date: '20/07/2020' },
  { methodology: 'EV/EBITA', min: 894000000, max: 954000000, date: '20/07/2020' },
  { methodology: 'FCF YIELD', min: 878000000, max: 946000000, date: '20/07/2020' },
  { methodology: 'DCF', min: 906000000, max: 988000000, date: '20/07/2020' },

  { methodology: 'EV/Revenues', min: 935000000, max: 995000000, date: '21/07/2020' },
  { methodology: 'EV/EBITA', min: 892000000, max: 956000000, date: '21/07/2020' },
  { methodology: 'FCF YIELD', min: 877000000, max: 944000000, date: '21/07/2020' },
  { methodology: 'DCF', min: 910000000, max: 990000000, date: '21/07/2020' },

  { methodology: 'EV/Revenues', min: 938000000, max: 990000000, date: '22/07/2020' },
  { methodology: 'EV/EBITA', min: 894000000, max: 956000000, date: '22/07/2020' },
  { methodology: 'FCF YIELD', min: 880000000, max: 944000000, date: '22/07/2020' },
  { methodology: 'DCF', min: 913000000, max: 991000000, date: '22/07/2020' },

  { methodology: 'EV/Revenues', min: 942000000, max: 1000000000, date: '23/07/2020' },
  { methodology: 'EV/EBITA', min: 897000000, max: 957000000, date: '23/07/2020' },
  { methodology: 'FCF YIELD', min: 882000000, max: 943000000, date: '23/07/2020' },
  { methodology: 'DCF', min: 916000000, max: 994000000, date: '23/07/2020' },

  { methodology: 'EV/Revenues', min: 946000000, max: 1005000000, date: '28/07/2020' },
  { methodology: 'EV/EBITA', min: 899000000, max: 859000000, date: '28/07/2020' },
  { methodology: 'FCF YIELD', min: 883000000, max: 942000000, date: '28/07/2020' },
  { methodology: 'DCF', min: 920000000, max: 996000000, date: '28/07/2020' },

  { methodology: 'EV/Revenues', min: 950000000, max: 1010000000, date: '29/07/2020' },
  { methodology: 'EV/EBITA', min: 900000000, max: 960000000, date: '29/07/2020' },
  { methodology: 'FCF YIELD', min: 882000000, max: 940000000, date: '29/07/2020' },
  { methodology: 'DCF', min: 920000000, max: 1000000000, date: '29/07/2020' }
];

export default dataValuationRetained;
